import React from 'react'
import { serverData } from '../../utils'
import { SecondaryHeader } from '../../components'
import FaceScan from './face-scan'

const TetherId = () => {
  const { selectedSubComponent } = serverData

  const SubComponent = {
    facescan: <FaceScan />,
  }

  return (
    <SecondaryHeader selectedTabId="privacyLink" selectedTabIndex={2}>
      {SubComponent[selectedSubComponent]}
    </SecondaryHeader>
  )
}

export default TetherId
